<template>
    <div class="slider-business-cars" :class="className">
        <div class="home-heading">
            <h2 v-if="title" v-html="title" />
        </div>
        <swiper class="slider-business-cars-carousel" :slides-per-view="1.3" :space-between="30" :centeredSlides="true" :loop="true" :breakpoints="perView ? perView : breakpointsCars" :modules="modules" :lazy="true" :pagination="{ type: 'bullets', clickable: true }" :autoplay="{ delay: 4000, disableOnInteraction: true }">
            <swiper-slide v-for="(car, index) in cars" :key="`business-car-${index}`">
                <Car business :car="car" :noDetails="false" :user="$attrs.user" @favorite_car="updateFavorites" />
            </swiper-slide>
        </swiper>
        <div v-if="withButton" class="slider-business-button">
            <Button outline :href="withButton.href">{{ withButton.title }}</Button>
        </div>
    </div>
</template>

<script>
    import Car from "../Car/CarBlock.vue";
    import { Swiper, SwiperSlide } from "swiper/vue";
    import { Pagination, Autoplay } from "swiper";
    import "swiper/css";
    import "swiper/css/pagination";
    import Button from "../../Components/Button/Button.vue";

    export default {
        components: {
            Car, Swiper, SwiperSlide, Button,
        },
        props: {
            cars: Array,
            perView: Object,
            className: String,
            title: String,
            description: String,
            withButton: Object     
        },
        setup() {
            return { modules: [Pagination, Autoplay] }
        },
        emits: ['favorite_car'],
        computed: {
            breakpointsCars() {
                return {
                    '1800': { slidesPerView: 1.8 },
                    '1600': { slidesPerView: 1.7 },
                    '1200': { slidesPerView: 1.4 },
                    '1100': { slidesPerView: 2 },
                    '600': { slidesPerView: 1.8 },
                    '460': { slidesPerView: 1.4 },
                }
            },
        },
        methods: {
            updateFavorites(id) {
                this.$emit('favorite_car', id)
            },
        }
    }
</script>